module.exports = __webpack_public_path__ + "static/media/B8.9e452ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/B8.png
// module id = 1296
// module chunks = 0